module.exports = __webpack_public_path__ + "static/media/thumbnail.57bc59c4.jpg";